"use strict";

var _classCallCheck = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\guest-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\guest-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _possibleConstructorReturn = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\guest-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\guest-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\guest-app\\node_modules\\@babel\\runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var paho_mqtt_1 = require("../../clients/paho-mqtt");

var pb_1 = require("./pb");

var ExtendedPropertyNotification =
/*#__PURE__*/
function (_pb_1$PropertyNotific) {
  _inherits(ExtendedPropertyNotification, _pb_1$PropertyNotific);

  function ExtendedPropertyNotification(properties) {
    var _this;

    _classCallCheck(this, ExtendedPropertyNotification);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ExtendedPropertyNotification).call(this, properties));
    _this.type = ExtendedPropertyNotification.type;
    return _this;
  }

  _createClass(ExtendedPropertyNotification, [{
    key: "toMQTT",
    value: function toMQTT() {
      var topic = "".concat(this.property).concat(ExtendedPropertyNotification.context);
      var mqttMessage = new paho_mqtt_1.Message(pb_1.PropertyNotification.encode(this).finish());
      mqttMessage.destinationName = topic;
      mqttMessage.qos = 1;
      return mqttMessage;
    }
  }], [{
    key: "fromMQTT",
    value: function fromMQTT(mqttMessage) {
      return new ExtendedPropertyNotification(pb_1.PropertyNotification.decode(mqttMessage.payloadBytes));
    }
  }]);

  return ExtendedPropertyNotification;
}(pb_1.PropertyNotification);

ExtendedPropertyNotification.type = "PropertyNotification";
ExtendedPropertyNotification.context = "/notification";
exports.PropertyNotification = ExtendedPropertyNotification;